import {
  FEATURED_VIDEOS,
  BIOS,
  QUOTES,
  ATHLETIC_TEAMS,
  GENERAL_EVENTS,
  GENERAL_CONTENTS,
  DASHBOARD,
  SPORT_EVENTS,
  POSTERS,
  EVENTS,
  CUSTOM_CONTENTS,
  AWS_BUCKET,
} from 'constants/appConstants'
import { checkTBDField } from 'utils/tbdField'

export const contentTypeMap = (contentType, result = {}, isSingle = false) => {
  const root = isSingle ? result.data.data : result

  const buildImgUrl = (attribute, format) => {
    let hash
    let ext
    if (format) {
      hash = root?.[attribute]?.formats?.[format]?.hash
      ext = root?.[attribute]?.formats?.[format]?.ext
    } else {
      hash = root?.[attribute]?.hash
      ext = root?.[attribute]?.ext
    }

    let url = ''
    if (hash !== undefined && ext !== undefined) {
      url = `${AWS_BUCKET}/${hash}${ext}`
    }
    console.log('url', attribute, format, url)
    return url
  }

  const isBio = () => {
    return {
      documentId: root.documentId,
      name: root?.name || root.name,
      previewImage: buildImgUrl('photo', 'ipadCard') || buildImgUrl('photo', null),
      altText: root?.photo?.alternativeText,
      description: root?.description,
      ilustrationUrl: buildImgUrl('ilustration', 'ipadSingle') || buildImgUrl('ilustration', null),
      ilustrationMime: root?.ilustration?.mime,
    }
  }

  const isQuote = () => {
    return {
      documentId: root.documentId,
      name: root?.name || root.name,
      description: root?.quotationText || root.quotationText,
      previewImage: buildImgUrl('photo', 'ipadCard') || buildImgUrl('photo', null),
      altText: root?.photo?.alternativeText || root.photo?.alternativeText,
      ilustrationUrl: buildImgUrl('ilustration', 'ipadSingle') || buildImgUrl('ilustration', null),
      ilustrationMime: root?.ilustration?.mime,
    }
  }

  const isGeneralContent = () => {
    return {
      documentId: root.documentId,
      name: root?.title || root.title,
      description: root?.text || root.text,
      previewImage: buildImgUrl('previewImage', 'ipadCard') || buildImgUrl('previewImage', null),
      ilustrationUrl: buildImgUrl('ilustration', 'ipadSingle') || buildImgUrl('ilustration', null),
      ilustrationMime: root?.ilustration?.mime,
    }
  }

  const isAthleticTeam = () => {
    return {
      documentId: root.documentId,
      name: root?.teamName || root.teamName,
      description: root?.description,
      ilustrationUrl: buildImgUrl('ilustration', 'ipadSingle') || buildImgUrl('ilustration', null),
      ilustrationMime: root?.ilustration?.mime,
    }
  }

  const isGeneralEvent = () => {
    return {
      documentId: root.documentId,
      name: root?.title || root.title,
      description: root?.location || root.location,
      ilustrationUrl: buildImgUrl('ilustration', 'ipadSingle') || buildImgUrl('ilustration', null),
      ilustrationMime: root?.ilustration?.mime,
      date: root?.date || root.date,
      time: root?.time || root.time,
    }
  }

  const isSportEvent = () => {
    return {
      documentId: root.documentId,
      name: checkTBDField(root?.primaryGroup || root.primaryGroup),
      description: checkTBDField(root?.opponent || root.opponent),
      ilustrationUrl: buildImgUrl('ilustration', 'ipadSingle') || buildImgUrl('ilustration', null),
      ilustrationMime: root?.ilustration?.mime,
      date: root?.date || root.date,
      time: root?.time || root.time,
    }
  }

  const isFeaturedVideo = () => {
    return {
      documentId: root.documentId,
      name: root?.title || root.title,
      description: root?.description,
      videoUrl: root?.video?.url,
      videoMime: root?.video?.mime,
      previewImage: buildImgUrl('previewImage', 'ipadCard') || buildImgUrl('previewImage', null),
    }
  }

  const isPoster = () => {
    return {
      documentId: root.documentId,
      name: root?.title || root.title,
      description: root?.text,
      previewImage: buildImgUrl('previewImage', 'ipadCard') || buildImgUrl('previewImage', null),
      altText: root?.previewImage?.alternativeText,
      ilustrationUrl: buildImgUrl('ilustration', 'ipadSingle') || buildImgUrl('ilustration', null),
      ilustrationMime: root?.ilustration?.mime,
    }
  }

  const isCustomContent = () => {
    return {
      documentId: root.documentId,
      name: root.title || root.title,
      description: root?.description,
      previewImage: buildImgUrl('image', 'ipadCard') || buildImgUrl('image', null),
      altText: root.image?.alternativeText,
      ilustrationUrl: buildImgUrl('image', 'ipadSingle') || buildImgUrl('image', null),
      ilustrationMime: root.image?.mime,
    }
  }

  const types = {
    [BIOS]: isBio,
    [QUOTES]: isQuote,
    [ATHLETIC_TEAMS]: isAthleticTeam,
    [GENERAL_EVENTS]: isGeneralEvent,
    [SPORT_EVENTS]: isSportEvent,
    [FEATURED_VIDEOS]: isFeaturedVideo,
    [GENERAL_CONTENTS]: isGeneralContent,
    [GENERAL_EVENTS]: isGeneralEvent,
    [POSTERS]: isPoster,
    [CUSTOM_CONTENTS]: isCustomContent,
  }

  return types[contentType] ? types[contentType]() : {}
}

export const contentTypesNames = (contentType, featured = false) => {
  const names = {
    [BIOS]: 'Bios',
    [QUOTES]: 'Quotes',
    [ATHLETIC_TEAMS]: 'All Teams',
    [GENERAL_EVENTS]: 'General Events',
    [SPORT_EVENTS]: 'Sport Events',
    featured_videos: 'Videos',
    general_contents: 'Generales',
    general_events: 'Eventos',
    [POSTERS]: 'Posters',
    [CUSTOM_CONTENTS]: 'More',
    [DASHBOARD]: 'Dashboard',
    [EVENTS]: 'Full Schedule',
  }

  const featuredNames = {
    [BIOS]: 'Bios',
    [QUOTES]: 'Quotes',
    [ATHLETIC_TEAMS]: 'Teams',
    featured_videos: 'Videos',
    general_contents: 'Generales',
    general_events: 'Eventos',
    [POSTERS]: 'Posters',
    [CUSTOM_CONTENTS]: 'More',
    [GENERAL_EVENTS]: 'General Events',
    [SPORT_EVENTS]: 'Sport Events',
  }

  return featured ? featuredNames[contentType] || '' : names[contentType] || ''
}

export const contentTypesArray = [
  // FEATURED_VIDEOS,
  'featured_videos',
  BIOS,
  QUOTES,
  ATHLETIC_TEAMS,
  GENERAL_EVENTS,
  DASHBOARD,
  SPORT_EVENTS,
  POSTERS,
  EVENTS,
  CUSTOM_CONTENTS,
]
